export default __webpack_public_path__ + "images/b0fe756d604951c1cf85b4b9fc633239.png";